import React from 'react';
import { Card } from 'antd';

import ProcessFollowUp from 'components/ProcessFollowUp';
import GetLabel from 'DisplayFramework/components/GetLabel';

type ContractManagersProps = {
  ctrid: number;
  phase: string;
  refetchProp: any;
  isActive?: boolean;
};
const ContractManagers = (props: ContractManagersProps) => {
  const { ctrid, phase,refetchProp,isActive } = props;
  return (
    <Card
      title={
        <GetLabel
          label="processFollowUp"
          style={{ fontWeight: 'bold', paddingLeft: 15 }}
        />
      }
      style={{
        width: '100%',
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
      }}
      bordered
      className="p-13"
    >
      {isActive && 
      <ProcessFollowUp
        entity={phase}
        entityid={ctrid}
        entityReference=""
        refetech={refetchProp}
      ></ProcessFollowUp>
}
    </Card>
  );
};

export default ContractManagers;
